import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import { Helmet } from 'react-helmet'
import netlifyIdentity from 'netlify-identity-widget'
import { getTitleSuffixed } from '../components/layout'
import { getDebugLogger } from '../utils/logger'

const REDIRECT_RELOAD_DELAY = 500 // in ms

const debug = getDebugLogger('LoginPage')

const loginHandler = () => {
  debug('loginHandler: redirecting to clients page')
  // Use window.location for absolute redirect to ensure proper path prefix handling
  if (typeof window !== 'undefined') {
    // Check if we're in production with /app prefix or development
    const baseUrl = window.location.origin
    const pathPrefix = window.location.pathname.includes('/app/') ? '/app' : ''
    const targetUrl = `${baseUrl}${pathPrefix}/clients`

    debug('loginHandler: navigating to', targetUrl)

    // Use location.href for a full page navigation that respects the path prefix
    setTimeout(() => {
      window.location.href = targetUrl
    }, 100)
  }
}

function showAuth() {
  debug('showAuth')
  // Open the login tab directly instead of signup
  netlifyIdentity.open('login')
  netlifyIdentity.on('close', () => netlifyIdentity.open('login'))
  netlifyIdentity.on('login', loginHandler)
}

export default function Login() {
  debug('rendering')

  useEffect(() => {
    showAuth()

    // Cleanup on unmount
    return () => {
      netlifyIdentity.off('login', loginHandler)
      netlifyIdentity.off('close')
    }
  }, [])

  return (
    <>
    <Helmet>
      <title>{ getTitleSuffixed('Login') }</title>
    </Helmet>
    </>
  )
}
